// @ts-nocheck: converted from JS

import StudyObservations from '@/components/Observations/Show';

export default StudyObservations;
